import React, { useCallback, useState } from 'react';

import { Button, Flex, Modal, Radio, Typography } from 'components';
import { CommentsReportEnum } from 'features/comments';
import useComments from 'features/comments/useComments';

const ReportModal = () => {
  const [repotyType, setReportType] = useState<CommentsReportEnum | null>(null);
  const [reported, setReported] = useState(false);

  const { setReportingCommentUuid, reportingCommentUuid, sendReport } = useComments();

  const handleClose = () => {
    setReported(false);
    setReportingCommentUuid('');
  };

  const handleSubmit = useCallback(() => {
    if (!reported) {
      if (repotyType !== null) {
        sendReport(reportingCommentUuid, repotyType, () => {
          setReported(true);
        });
      }
    } else {
      handleClose();
    }
  }, [reportingCommentUuid, repotyType, reported]);

  return (
    <Modal bg="dark_150" onClose={handleClose}>
      <Flex width={{ m: 300 }} flexDirection="column">
        <Flex
          bg="dark_350"
          height={50}
          pl={{ m: 4, d: 5 }}
          alignItems="center"
          flexShrink={0}
          borderTopLeftRadius={4}
          borderTopRightRadius={4}
          borderBottomWidth={1}
          borderBottomStyle="solid"
          borderBottomColor="gray_600"
        >
          <Typography type="type2" upper color="white">
            Denunciar
          </Typography>
        </Flex>

        <Flex flexGrow={1} px={{ m: 4, d: 5 }} py={{ m: 3, d: 4 }} flexDirection="column">
          {reported ? (
            <>
              <Typography type="type2" color="white" fontWeight="bold">
                Obrigado.
              </Typography>

              <Typography type="type1" color="white" lineHeight={1.3} mt={2}>
                Recebemos sua denúncia. Se este conteúdo estiver violando as diretrizes da comunidade, ele será removido.
              </Typography>
            </>
          ) : (
            <>
              {[
                [CommentsReportEnum.PersonalAttack, 'Ataque pessoal'],
                [CommentsReportEnum.HateSpeech, 'Discusso de ódio'],
                [CommentsReportEnum.Language, 'Linguagem inapropriada'],
                [CommentsReportEnum.Spam, 'Spam ou fraude'],
                [CommentsReportEnum.FakeNews, 'Informação falsa'],
                [CommentsReportEnum.SexualActivity, 'Atividade sexual'],
                [CommentsReportEnum.Other, 'Outros'],
              ].map((option, index) => (
                <Flex
                  mt={index ? 2 : 0}
                  alignItems="center"
                  onClick={() => setReportType(option[0] as CommentsReportEnum)}
                  style={{ cursor: 'pointer' }}
                >
                  <Radio value={option[0]} checked={repotyType === option[0]} />
                  <Typography color="white" ml={2}>
                    {option[1]}
                  </Typography>
                </Flex>
              ))}
            </>
          )}
        </Flex>

        <Flex height={50} flexShrink={0} alignItems="stretch">
          <Button
            size="small"
            bg="dark_350"
            bgHover="dark_150"
            borderTopLeftRadius={0}
            borderTopRightRadius={0}
            borderBottomLeftRadius={4}
            borderBottomRightRadius={4}
            width="100%"
            height="auto"
            borderTopWidth={1}
            borderTopStyle="solid"
            borderTopColor="gray_600"
            onClick={handleSubmit}
          >
            {reported ? 'OK' : 'Denunciar'}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ReportModal;
